// ============================================================
// Zentryx Dominó - Game Constants
// ============================================================

/** Casino-premium color palette */
export const COLORS = {
  // Backgrounds
  CASINO_DARK: 0x0a1f14,
  CASINO_GREEN: 0x1a3a2a,
  CASINO_FELT: 0x1e4d35,

  // Gold
  GOLD: 0xd4af37,
  GOLD_LIGHT: 0xf0d060,
  GOLD_DARK: 0xb8960c,

  // Tile
  TILE_WHITE: 0xf5f0e8,
  TILE_SHADOW: 0xc4b898,
  TILE_DOT: 0x1a1a1a,

  // Accents
  ACCENT_RED: 0xe74c3c,
  ACCENT_BLUE: 0x3498db,
  ACCENT_GREEN: 0x2ecc71,
  ACCENT_PURPLE: 0x9b59b6,

  // Text
  TEXT_WHITE: 0xf5f5f5,
  TEXT_MUTED: 0x8faa9a,

  // UI
  UI_PANEL_BG: 0x0d2a1c,
  UI_PANEL_BORDER: 0x2a5a3a,
  UI_BUTTON_BG: 0x1a3a2a,
} as const;

/** CSS color strings (for text/DOM) */
export const CSS_COLORS = {
  CASINO_DARK: '#0a1f14',
  CASINO_GREEN: '#1a3a2a',
  GOLD: '#d4af37',
  GOLD_LIGHT: '#f0d060',
  TEXT_WHITE: '#f5f5f5',
  TEXT_MUTED: '#8faa9a',
  ACCENT_GREEN: '#2ecc71',
  ACCENT_RED: '#e74c3c',
} as const;

/** Tile dimensions */
export const TILE = {
  WIDTH: 50,
  HEIGHT: 90,
  HALF_HEIGHT: 42,
  DOT_RADIUS: 5,
  CORNER_RADIUS: 6,
  BORDER_WIDTH: 2,
  GAP: 4,
  BOARD_SCALE: 0.7,
  HAND_SCALE: 1.0,
} as const;

/** Animation durations (ms) */
export const ANIM = {
  DEAL_DURATION: 350,
  DEAL_STAGGER: 80,
  TILE_HOVER_UP: 150,
  TILE_HOVER_DOWN: 200,
  TILE_PLAY: 400,
  TILE_FLIP: 500,
  TILE_SHAKE: 300,
  TILE_GLOW_PULSE: 1200,
  SCENE_TRANSITION: 600,
  TOAST_SHOW: 300,
  TOAST_HIDE: 200,
  TOAST_STAY: 2000,
  COIN_COUNT: 800,
  XP_BAR_FILL: 1000,
  CONFETTI_DURATION: 3000,
  AI_THINK_MIN: 800,
  AI_THINK_MAX: 1800,
} as const;

/** Game rules */
export const RULES = {
  MAX_PIP: 6 as const,
  TILES_PER_PLAYER_2P: 7,
  TILES_PER_PLAYER_3P: 7,
  TILES_PER_PLAYER_4P: 5,
  TOTAL_TILES: 28,
} as const;

/** Economy values */
export const ECONOMY = {
  WIN_COINS_BASE: 100,
  WIN_COINS_PER_PIP: 2,
  LOSE_COINS: 25,
  DRAW_COINS: 50,
  WIN_XP: 75,
  LOSE_XP: 20,
  DRAW_XP: 35,
  LEVEL_XP_BASE: 100,
  LEVEL_XP_MULTIPLIER: 1.3,
} as const;

/** Progression thresholds */
export const RANKS = {
  bronze: { minLevel: 1, maxLevel: 5, name: 'Bronce', emoji: '🥉' },
  silver: { minLevel: 6, maxLevel: 15, name: 'Plata', emoji: '🥈' },
  gold: { minLevel: 16, maxLevel: 30, name: 'Oro', emoji: '🥇' },
  diamond: { minLevel: 31, maxLevel: 50, name: 'Diamante', emoji: '💎' },
  legend: { minLevel: 51, maxLevel: 999, name: 'Leyenda', emoji: '👑' },
} as const;

/** Scene keys */
export const SCENES = {
  BOOT: 'BootScene',
  MENU: 'MenuScene',
  GAME: 'GameScene',
  SHOP: 'ShopScene',
  RESULT: 'ResultScene',
} as const;

/** Z-depth layers */
export const DEPTH = {
  BACKGROUND: 0,
  BOARD: 10,
  BOARD_TILES: 20,
  OPPONENT_HAND: 30,
  PLAYER_HAND: 40,
  HAND_TILES: 50,
  HUD: 100,
  PARTICLES: 150,
  OVERLAY: 200,
  TOAST: 250,
  POPUP: 300,
} as const;
